<template>
    <div class="page-heading">
        <h1>{{ heading }}</h1>

        <p v-if="subheading">{{ subheading }}</p>
    </div>
</template>

<script setup lang="ts">
defineProps<{ heading: string; subheading?: string }>();
</script>

<style scoped>
.page-heading {
    min-width: 300px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 0 12px;
}

.page-heading h1 {
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
}

.page-heading p {
    color: var(--text-secondary);
}

@media (min-width: 650px) {
    .page-heading {
        max-width: 600px;
        padding: 0;
    }
}

@media (min-width: 840px) {
    .page-heading {
        margin-left: 0;
        padding: 0 16px;
    }
}
</style>
